import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import store from '@/store'

const ability = store.state.auth.ability
const chunkReloadStorageKey = 'jaes.sft.chunk-load-reload-attempted'

const isChunkLoadError = (error) => {
    const message = String(error?.message ?? '')
    return error?.name === 'ChunkLoadError'
        || /Loading chunk [\d]+ failed/i.test(message)
        || /CSS_CHUNK_LOAD_FAILED/i.test(message)
}

const reloadOnceAfterChunkLoadError = (error) => {
    if (!isChunkLoadError(error) || typeof window === 'undefined') return

    if (sessionStorage.getItem(chunkReloadStorageKey) === '1') {
        // Si el reload ya se intentó, evitamos un bucle infinito y dejamos que el error suba.
        sessionStorage.removeItem(chunkReloadStorageKey)
        return
    }

    // Un chunk desincronizado suele indicar que hay una versión nueva desplegada.
    // Recargamos una sola vez para recuperar el bundle correcto.
    sessionStorage.setItem(chunkReloadStorageKey, '1')
    window.location.reload()
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior (to, from, savedPosition) {
        let position = { left: 0, top: 0 }
        if (savedPosition) position = savedPosition
        const mainDiv = document.getElementById('main-div')
        if (mainDiv) mainDiv.scroll(position)
        return position
    }
})

// Fallback para cuando un chunk lazy-loaded falla por caché o por un despliegue intermedio.
router.onError(reloadOnceAfterChunkLoadError)
router.isReady().then(() => {
    // Si la app arranca bien, limpiamos la marca para que el siguiente fallo pueda reintentar una vez.
    sessionStorage.removeItem(chunkReloadStorageKey)
}).catch(() => {})

//Control de rutas privadas
router.beforeEach((to, from, next) => {
    //Comprobamos si la ruta tiene definida la meta requiresAuth
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const currentUser = store.getters['auth/getCurrentUser']
    const { authorize, subject } = to.meta

    if (!requiresAuth && currentUser && to.path === '/login') {
        //Si el usuario está logueado e intenta volver al login, redirigimos a /
        return next('/')
    } else if (requiresAuth && !currentUser) {
        //Si el usuario no está logueado impedimos que acceda a /
        return next('/login')
    } else if (currentUser && authorize && !authorize.includes(currentUser.role)) {
        //Perfil no autorizado
        return next({ path: '/' })
    } else if (!['/', '/login'].includes(to.path) && subject && !ability.can('read', subject)) {
        //Perfil no autorizado
        return next({ path: '/' })
    }
    return next()
})

export default router
